import { createTheme } from '@mui/material/styles';

// Palette matches the approved Cheers2Night reference design: dark navy background,
// gold primary, muted gray secondary text. Centralized here so pages stop repeating
// hardcoded hex sx props — see PROPOSE_UI_COLORS below for the raw tokens if a
// one-off component still needs a value outside the theme (image accents, etc.)
export const PROPOSE_UI_COLORS = {
  background: '#05070D',
  surface: '#0B101A',
  surfaceAlt: '#101722',
  primary: '#F5C542',
  textMuted: '#9AA3B2',
  success: '#22C55E',
  purple: '#A855F7',
  pink: '#EC4899',
  cyan: '#22D3EE'
};

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: PROPOSE_UI_COLORS.background,
      paper: PROPOSE_UI_COLORS.surface
    },
    primary: {
      main: PROPOSE_UI_COLORS.primary,
      contrastText: '#000'
    },
    success: {
      main: PROPOSE_UI_COLORS.success
    },
    text: {
      primary: '#F5F6F8',
      secondary: PROPOSE_UI_COLORS.textMuted
    },
    divider: 'rgba(245, 246, 248, 0.08)'
  },
  typography: {
    fontFamily: "'Space Grotesk', 'Open Sans', sans-serif",
    h1: { fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 },
    h2: { fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 },
    h3: { fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 },
    h4: { fontFamily: "'Cormorant Garamond', serif", fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 700 }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: PROPOSE_UI_COLORS.background,
          color: '#F5F6F8'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: PROPOSE_UI_COLORS.surface,
          border: '1px solid rgba(245, 246, 248, 0.08)'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          background: `linear-gradient(135deg, ${PROPOSE_UI_COLORS.primary}, #E0AC1F)`,
          color: '#000',
          '&:hover': {
            background: `linear-gradient(135deg, #E0AC1F, ${PROPOSE_UI_COLORS.primary})`
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600
        }
      }
    }
  }
});

export default theme;
